import React from 'react';
import {Progress} from 'reactstrap'
import {Pie, PieChart, ResponsiveContainer} from 'recharts';
import Panel from '../../../shared/components/Panel';
import {withTranslation} from "react-i18next";

const WeeklyStat = ({resource_credits, voting_manabar, downvote_manabar, onRefresh, loading, t}) => (
    <Panel
        xs={12}
        md={12}
        lg={6}
        xl={4}
        title={t('overview.your_power.title')}
        subhead={t('overview.your_power.subtitle')}
        onRefresh={onRefresh}
        loading={loading}
    >
        <div className="dashboard__weekly-stat">
            <div className="dashboard__weekly-stat-chart">
                <div className="dashboard__weekly-stat-chart-item">
                    <div className="dashboard__weekly-stat-chart-pie">
                        <ResponsiveContainer>
                            <PieChart className="dashboard__weekly-stat-chart-pie-wrapper">
                                <Pie
                                    data={[
                                        {value: parseFloat(voting_manabar), fill: '#4ce1b6'},
                                        {value: 100 - parseFloat(voting_manabar), fill: '#eeeeee'}
                                    ]}
                                    dataKey="value"
                                    cx={50}
                                    cy={50}
                                    innerRadius={50}
                                    outerRadius={55}
                                />
                            </PieChart>
                        </ResponsiveContainer>
                        <p className="dashboard__weekly-stat-label" style={{color: '#4ce1b6'}}>{voting_manabar}%</p>
                    </div>
                    <div className="dashboard__weekly-stat-info">
                        <p>{t('overview.your_power.voting_mana')}</p>
                    </div>
                </div>
                <div className="dashboard__weekly-stat-chart-item">
                    <div className="dashboard__weekly-stat-chart-pie">
                        <ResponsiveContainer>
                            <PieChart className="dashboard__weekly-stat-chart-pie-wrapper">
                                <Pie
                                    data={[
                                        {value: parseFloat(downvote_manabar), fill: '#ff4861'},
                                        {value: 100 - parseFloat(downvote_manabar), fill: '#eeeeee'}
                                    ]}
                                    dataKey="value"
                                    cx={50}
                                    cy={50}
                                    innerRadius={50}
                                    outerRadius={55}
                                />
                            </PieChart>
                        </ResponsiveContainer>
                        <p className="dashboard__weekly-stat-label" style={{color: '#ff4861'}}>{downvote_manabar}%</p>
                    </div>
                    <div className="dashboard__weekly-stat-info">
                        <p>{t('overview.your_power.downvote_mana')}</p>
                    </div>
                </div>
            </div>
            <div className="progress-wrap progress-wrap--blue-gradient progress-wrap--big">
                <p>{t('overview.your_power.resource_credits')}</p>
                <Progress value={resource_credits}>{resource_credits}%</Progress>
            </div>
        </div>
    </Panel>
);

export default withTranslation('dashboard')(WeeklyStat);
